import React from 'react';
import cls from 'classnames';
import styles from './CenteredWithIcon.scss';

/** @deprecated use string literal instead */
export enum ICON_POSITION {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

/** @deprecated use string literal instead */
export enum ICON_ANCHOR {
  EDGE = 'EDGE',
  TEXT = 'TEXT',
}

export type CenteredWithIconType = {
  /**
   * Компонент отображения иконки
   */
  IconComponent: React.ComponentType<any>;
  /**
   * Позиционирование относительно текста
   */
  position?: 'LEFT' | 'RIGHT';
  /**
   * Позиционирование внутри кнопки
   */
  anchor?: 'EDGE' | 'TEXT';
  /**
   * Для управления позиционированием основного контента, кейс: текст начинается с границы кнопки
   */
  hasNoSpacer?: boolean;
  /**
   * Свой класс для управления стилями иконки
   */
  className?: string;
  /**
   * Основной контент
   */
  children?: React.ReactNode;
};

const CenteredWithIcon: React.FC<CenteredWithIconType> = ({
  children = null,
  IconComponent,
  position = 'LEFT',
  anchor = 'TEXT',
  hasNoSpacer = false,
  className,
}) => {
  const iconNode = (
    <div className={styles.buttonIcon}>
      {/* @ts-ignore */}
      <IconComponent className={className} />
    </div>
  );

  const shouldAlignToEdge = anchor === 'EDGE';
  const spacerNode =
    shouldAlignToEdge && !hasNoSpacer ? <div className={styles.buttonSpacer} /> : null;

  return (
    <div className={cls(styles.buttonContainer, { [styles.alignToEdge]: shouldAlignToEdge })}>
      {position === 'LEFT' ? iconNode : spacerNode}
      {children && <div className={styles.buttonCaption}>{children}</div>}
      {position === 'RIGHT' ? iconNode : spacerNode}
    </div>
  );
};

export default CenteredWithIcon;
